export default (firstname, lastname) => {
    return `${Array.from(firstname)[0]}${Array.from(lastname)[0]}`
}